var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full flex justify-start mt-3"},[_c('button',{staticClass:"btn btn--primary",on:{"click":function($event){return _vm.generateExport()}}},[_vm._v("Exportar")])])
}
var staticRenderFns = []

export { render, staticRenderFns }